import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {lastValueFrom} from "rxjs";
import {LatitudeFrontendSettings} from "./latitude-frontend-settings";


@Injectable({
    providedIn: 'root'
})
export class ApplicationSettingsService {

    private loaded: boolean;
    settings: LatitudeFrontendSettings;

	constructor(private http: HttpClient) {
	}

	loadConfig (): Promise<void> {
		return lastValueFrom(this.http.get<LatitudeFrontendSettings>("./assets/config/application_settings.json")).then((data) => {

            this.settings = data;
			// console.log("environment config is ready: ", this.settings);
			this.loaded = true;
		});
	}

    hasConfig (): boolean {
        return this.loaded;
    }
}
